// TODO: From App New
export default [
  {
    type: 'section',
    title: 'Informasi Sale',
    description: 'Isi informasi sale dengan lengkap untuk menarik lebih banyak pembeli.',
  },
  {
    key: 'title',
    label: 'Judul',
    required: true,
    maxLength: 255,
    notes: [
      'Judul sale yang akan ditampilkan kepada pengguna.',
      'Maksimal 255 karakter.',
    ],
  },
  {
    key: 'description',
    label: 'Deskripsi',
    type: 'textarea',
    rows: 4,
    notes: 'Deskripsi detail tentang sale ini (opsional).',
  },
  {
    key: 'should_started_at',
    label: 'Dimulai pada',
    type: 'datetime',
    required: true,
    notes: 'Tanggal dan waktu dimulainya sale.',
  },
  {
    key: 'should_ended_at',
    label: 'Berakhir pada',
    type: 'datetime',
    required: true,
    notes: 'Tanggal dan waktu berakhirnya sale.',
  },
  {
    key: 'is_active',
    label: 'Status',
    type: 'radio',
    required: true,
    notes: 'Sale akan dapat dilihat oleh pengguna apabila Aktif.',
    options: [
      {
        value: true,
        text: 'Aktif',
      },
      {
        value: false,
        text: 'Tidak Aktif',
      },
    ],
  },
  // {
  //   type: 'section',
  //   title: 'Banner dan Popup',
  //   description: 'Unggah gambar banner dan popup untuk sale ini.',
  // },
  // {
  //   key: 'banner_media_id',
  //   image: 'banner_image_url',
  //   label: 'Foto Banner',
  //   type: 'image',
  //   notes: [
  //     'Unggah gambar banner untuk sale ini (opsional).',
  //     'Disarankan menggunakan rasio 16:9 untuk tampilan optimal.',
  //   ],
  // },
  // {
  //   key: 'banner_url',
  //   label: 'Banner URL',
  //   maxLength: 255,
  //   notes: [
  //     'URL yang akan dibuka ketika banner diklik (opsional).',
  //     'Maksimal 255 karakter.',
  //   ],
  // },
  // {
  //   key: 'popup_media_id',
  //   image: 'popup_image_url',
  //   label: 'Foto Popup',
  //   type: 'image',
  //   notes: [
  //     'Unggah gambar popup untuk sale ini (opsional).',
  //     'Disarankan menggunakan rasio persegi untuk tampilan optimal.',
  //   ],
  // },
  // {
  //   key: 'popup_url',
  //   label: 'Popup URL',
  //   maxLength: 255,
  //   notes: [
  //     'URL yang akan dibuka ketika popup diklik (opsional).',
  //     'Maksimal 255 karakter.',
  //   ],
  // },
]
